import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { Enums } from '../../../../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-ticket-checker',
  templateUrl: './ticket-checker.component.html',
  styleUrls: ['./ticket-checker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TicketCheckerComponent implements OnInit, OnChanges {
  private moment = require('moment');
  public isCanAssignTicket: boolean;

  @Input() ticket;
  @Input() ticketsMultipleAssign;
  @Input() ticketsCurrentFilter;
  @Input() isMatrix;

  constructor() {}

  ngOnInit() {
    this.makeConstants();
  }

  public makeConstants(): void {
    if (this.ticketsMultipleAssign && this.ticketsMultipleAssign.canAssignTicket) {
      this.isCanAssignTicket = this.ticketsMultipleAssign.canAssignTicket(this.ticket);
      return;
    }

    const ticketVKStatus = this.ticket.ticket_status.id;
    const ticketHDStatus = this.ticket.hd_ticket_status.id;

    // Упрощенная логика: чекбоксы доступны для всех заявок,
    // которые не в финальном статусе (6 - "Отменена" или 8 - "Выполнена")
    // И НЕ в статусе HD=194 и ВК=12
    this.isCanAssignTicket = ticketVKStatus !== 6 && ticketVKStatus !== 8 && !(ticketHDStatus === 194 && ticketVKStatus === 12);

    // Старая логика (закомментирована):
    /*
    const dateShortFormat = Enums.dates.shortFormat;
    const ticketScheduleDate = this.moment(this.ticket.hd_schedule_date).valueOf();
    const daysAssignLimit = (this.ticketsCurrentFilter && this.ticketsCurrentFilter.ticketsSettings && this.ticketsCurrentFilter.ticketsSettings.days_for_assignment) || 2;

    const workingDateAssign = this.ticketsCurrentFilter && this.ticketsCurrentFilter.ticketsSettings && this.ticketsCurrentFilter.ticketsSettings.tomorrow_assignment_time;

    const countDaysAdd = this.ticketsCurrentFilter && this.ticketsCurrentFilter.ticketsSettings && this.ticketsCurrentFilter.assignDaySelected.countDays;

    const firstAssignDate = this.moment(this.moment(workingDateAssign).add(countDaysAdd, 'day').format(dateShortFormat)).startOf('day').valueOf();

    const endAssignDate = this.moment(this.moment(workingDateAssign).format(dateShortFormat))
      .add(daysAssignLimit + countDaysAdd, 'day')
      .endOf('day')
      .valueOf();

    this.isCanAssignTicket = (ticketScheduleDate >= firstAssignDate && ticketScheduleDate <= endAssignDate && ticketVKStatus !== 6 && ticketVKStatus !== 8) || false;
    */
  }
  public ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.ticketsCurrentFilter && changes.ticketsCurrentFilter.currentValue) {
      this.makeConstants();
    }
  }

  public onCheckedTicket(): void {
    this.ticketsMultipleAssign.onCheckedTicket();
  }
}
